import { getUserLocation } from '../geoLocation';

//Create a User Profile When User Logs in (On User Login)
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function updateUserProperties(profileData: any): void {
  const { clevertap }: any = window;
  if (clevertap) {
    clevertap.onUserLogin.push({
      Site: profileData
    });
  }
}

interface LocationData {
  currentCountryCode: string | null;
  currentCountryName: string | null;
  currentState: string | null;
  currentCity: string | null;
}

export const pushGeoLocationDataToCT = async (): Promise<any> => {
  try {
    const {
      currentCountryCode,
      currentCountryName,
      currentState,
      currentCity
    }: LocationData | any = (await getUserLocation()) || {};
    if (currentCountryCode || currentCountryName || currentState || currentCity)
      updateUserProperties({
        currentCountryCode: currentCountryCode?.toUpperCase(),
        currentCountryName,
        currentState,
        currentCity
      });
  } catch (exception) {
    // @ts-ignore
    // eslint-disable-next-line
    console.log(exception?.message);
  }
};
